const globalProductCellData = {}


 class ProductCell {

  constructor(productId){
    this.productId = productId;
    this.eventHandlers();
  }

  static changeProductImage(element, newSrc) {
    element.style.backgroundImage = `url(${newSrc})`;
  }
  static preloadImage(url) {
    const img = new Image();
    img.src = url;
  }


  removeColorTitle(selector){
    function removeTextAfterSecondDash(text) {
        const parts = text.split(' - ');
        return parts.slice(0, 2).join(' - ').trim();
    }
    const element = document.querySelectorAll(selector);
    element.forEach(element =>{
      element.textContent = removeTextAfterSecondDash(element.textContent);
    })
  }
  
  handleQuickAddToCart(){
    const cell = document.querySelector(`#js-product-cell-${this.productId}`);
    if(!cell) return
    const addToCartForm = cell.querySelectorAll(".grid-quick-add");

    addToCartForm.forEach(form => {
      form.addEventListener("submit", e=> {
        e.preventDefault();
        
        addItemAJAX(form.id.value, 1)

        let hasCartOpened = false;

  
        document.addEventListener("limoniapps:discountninja:cart:updated", function (event) {
          let ninjaCart = event.detail.data[0];
          cart.renderCart(ninjaCart);
          
          if(!hasCartOpened){
            cart.openCart()
            hasCartOpened = true;
          }
        });
      })
    })
  }

  changeVariant(id, variantsData) {
    const cell = document.querySelector(`#js-product-cell-${id}`);
    if(!cell) return
    const switcherFieldsets = cell.querySelectorAll("fieldset");
  
    function changeHtml(data) {
      const html_absorptionAndPrice = /*html*/ `
        <div class="tw-flex tw-items-center tw-gap-[6px]">
          ${data.absorption_svg} 
          <span class="tw-text-[#666666] tw-font-sans tw-text-[14px] lg:tw-block tw-hidden [&_p]:tw-m-0">${data.absorption_text}</span>  
          </div>
        <div class="tw-flex tw-items-center tw-gap-[6px]">
          <span class="tw-line-through tw-opacity-60 tw-text-[14px] tw-font-sans tw-font-[500]"></span>
          <span class="tw-text-[14px] tw-font-sans tw-font-[500]">${data.price}</span>
        </div>`;

        function generateBadge(text){
          return `<div class="discount tw-text-white tw-font-serif tw-text-[16px] tw-text-base tw-font-[500] tw-uppercase tw-leading-[21px] tw-rounded-[100px] tw-flex tw-bg-orange-fe tw-justify-center tw-p-[12px] tw-m-0 max-[599px]:tw-text-[12px] max-[599px]:tw-py-[8px] max-[599px]:tw-leading-[16px]">${text}</div>`
        }

        const titleElement = cell.querySelector(".js-product-cell-title");
        if (titleElement) {
          const changeTitle = (titleElement.textContent = data.title);
        }
        
        const imgElement = cell.querySelector(".ie-image");
        if (imgElement) {
          const changeImg = (imgElement.style.backgroundImage = `url(${data.front_image})`);
          const changeId = (imgElement.id = `product-img-${data.id}`);
          const changeHoverImgFront = imgElement.setAttribute("onmouseout", `ProductCell.changeProductImage(this, '${data.front_image}')`);
          const changeHoverImgBack = imgElement.setAttribute("onmouseover", `ProductCell.changeProductImage(this, '${data.back_image}')`);
        }
        
        const anchorElement = cell.querySelector("a");
        if (anchorElement) {
          const changeUrl = (anchorElement.href = data.url);
        }
        let badges = cell.querySelector(".badges");
        
        badges.innerHTML = ""
        data.badges.forEach(badge => {
          badges.insertAdjacentHTML("beforeend", generateBadge(badge))
        })

        const absorptionAndPriceElements = cell.querySelectorAll(".ie-absorption-price");
        absorptionAndPriceElements.forEach((element) => {
          element.innerHTML = html_absorptionAndPrice;
        });
        
        const inputsElement = cell.querySelector(".swiper-wrapper");
        const inputsElementNoVariants = cell.querySelector(".ie-product-hover-buy");
        if (inputsElement) {
          const changeInputs = (inputsElement.innerHTML = data.inputHtml);
        } else if(inputsElementNoVariants){
          const changeInputs = (inputsElementNoVariants.innerHTML = data.inputHtmlNoVariants);
        }
        
        const mobileModalElement = cell.querySelector(".ie-modal-js-selector");
        if (mobileModalElement) {
          const changeMobileModal = (mobileModalElement.innerHTML = data.modalHtml);
        }
        
        const fieldsetElement = cell.querySelector(".ie-js-fieldset");
        if (fieldsetElement) {
          const changeFieldset = (fieldsetElement.innerHTML = data.colorFieldsetHTML);
        }
      }

      switcherFieldsets.forEach((fieldset) => {
      const inputs = fieldset.querySelectorAll("input");
  
      inputs.forEach((swatch) => {
        swatch.addEventListener("change", (ev) => {
          if (ev.target.checked) {
            variantsData.forEach((variantData) => {
              if (variantData.id == ev.target.dataset.id) {
                changeHtml(variantData, this);
                this.changeVariants();
                quickMobileLoad();
                this.handleQuickAddToCart();
              }
            });
          }
        });
      });
    });
  }

  changeVariants() {
      let data = globalProductCellData[`subproductsData_${this.productId}`];
      this.changeVariant(this.productId, data);
  }

  eventHandlers(){
    // Custom event in facets.js that listenes for filter render
    document.body.addEventListener("gridFiltered", e => {
      this.changeVariants();
    })

    // Load event
      this.handleQuickAddToCart();
      this.changeVariants();
  }
}
 
function countSubtotalCart(subtotalPrice) {
  const selectors = {
    compareAtPrice: ".original-price",
    price: ".new-price"
  }
  
  const cart = location.pathname == "/cart";
  let subtotalCompareAtPrice;
  if(cart){
    subtotalCompareAtPrice = document.querySelector("#ie-custom-subtotal");
  } else {
    subtotalCompareAtPrice = document.querySelector("#ie-custom-subtotal-drawer");
  }

  const allProductPrices = document.querySelectorAll(".ie-custom-product-price > .money");
  let subtotalCompare = 0;
  

  function makeNumberOutOfString(string){
    let corrector = 1;
    if(string.includes("Kč")) corrector = 100;
    return (parseFloat(string.replace(/[^0-9.]/g, '')) * corrector);
  }

  
  if(!subtotalCompareAtPrice || !allProductPrices) return
  allProductPrices.forEach(product => {
    const compareAtPrice = product.querySelector(selectors.compareAtPrice)?.innerText;
    const price = product.querySelector(selectors.price)?.innerText;
    
    if(compareAtPrice) return subtotalCompare += makeNumberOutOfString(compareAtPrice);
    if(price) return subtotalCompare += makeNumberOutOfString(price);
  })

  if(subtotalCompare <= subtotalPrice) return subtotalCompareAtPrice.innerText = ""
  
  return subtotalCompareAtPrice.innerText = Shopify.formatMoney(subtotalCompare, Theme.moneyFormat)
}



